import { z } from 'zod';
import { timesheetsPayrollCurrencyCodeSchema, timesheetsPayrollMoneyCentsSchema, timesheetsPayrollSecondsSchema, } from './timesheets-payroll-cost-summary.contract.js';
export const timesheetsFinanceProfitabilityLaborCapability = 'timesheets.finance-profitability-labor.v1';
export const timesheetsFinanceProfitabilityLaborSlot = 'finance.project-profitability.labor';
export const timesheetsFinanceProfitabilityLaborProviderId = 'timesheets.server.finance-profitability-labor';
export const timesheetsFinanceProfitabilityLaborRequestSchema = z.strictObject({
    consumerModuleId: z.literal('finance'),
    requestedCapability: z.literal('finance.project-profitability.v1'),
    resourceType: z.literal('finance.project-profitability'),
    resourceId: z.string().uuid(),
    fromInclusive: z.string().datetime({ offset: true }),
    toExclusive: z.string().datetime({ offset: true }),
    projects: z.array(z.strictObject({
        projectId: z.string().uuid(),
        createdAt: z.string().datetime({ offset: true }),
    })).min(1).max(500),
}).superRefine((request, context) => {
    if (new Date(request.toExclusive).getTime() <= new Date(request.fromInclusive).getTime()) {
        context.addIssue({ code: 'custom', path: ['toExclusive'], message: 'Labor range must be positive.' });
    }
    const ids = request.projects.map(({ projectId }) => projectId);
    if (new Set(ids).size !== ids.length) {
        context.addIssue({ code: 'custom', path: ['projects'], message: 'Labor Projects cannot repeat.' });
    }
});
export const timesheetsFinanceProfitabilityLaborProjectSchema = z.discriminatedUnion('state', [
    z.strictObject({
        state: z.literal('present'),
        projectId: z.string().uuid(),
        currencyCode: timesheetsPayrollCurrencyCodeSchema,
        trackedWorkSeconds: timesheetsPayrollSecondsSchema,
        payableEntryCount: z.number().int().nonnegative(),
        pendingEntryCount: z.number().int().nonnegative(),
        payableLaborCents: timesheetsPayrollMoneyCentsSchema,
        pendingLaborCents: timesheetsPayrollMoneyCentsSchema,
        totalLaborCostCents: timesheetsPayrollMoneyCentsSchema,
        policyVersionIds: z.array(z.string().uuid()).max(10_000),
    }).superRefine((fact, context) => {
        if (fact.totalLaborCostCents !== fact.payableLaborCents + fact.pendingLaborCents) {
            context.addIssue({
                code: 'custom', path: ['totalLaborCostCents'], message: 'Labor costs do not reconcile.',
            });
        }
    }),
    z.strictObject({
        state: z.literal('unavailable'),
        projectId: z.string().uuid(),
        reasonCode: z.enum([
            'history-truncated',
            'basis-incomplete',
            'currency-mismatch',
            'permission-denied',
        ]),
    }),
]);
export const timesheetsFinanceProfitabilityLaborResponseSchema = z.strictObject({
    contractVersion: z.literal(timesheetsFinanceProfitabilityLaborCapability),
    tenantId: z.string().uuid(),
    fromInclusive: z.string().datetime({ offset: true }),
    toExclusive: z.string().datetime({ offset: true }),
    projects: z.array(timesheetsFinanceProfitabilityLaborProjectSchema).min(1).max(500),
}).superRefine((response, context) => {
    const ids = response.projects.map(({ projectId }) => projectId);
    if (new Set(ids).size !== ids.length) {
        context.addIssue({ code: 'custom', path: ['projects'], message: 'Labor facts cannot repeat.' });
    }
});
//# sourceMappingURL=timesheets-finance-profitability-labor.contract.js.map